module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Diagnostics-8ad9be6130a015fd8b33071b0f438055.svg";